<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  import { mapActions, mapState } from 'vuex'
  import { clone } from 'lodash'
  import SingleSelectInput from '@/components/ui/SingleSelectInput'

  export default {
    name: 'SearchFilter',
    components: {
      SingleSelectInput,
    },
    data() {
      return {
        filters: {},
        isDisabled: true,
      }
    },
    computed: {
      ...mapState('news', ['filterOptions']),
    },
    watch: {
      'filters.types': {
        handler(val) {
          if (val && val.key !== 'post') {
            this.getTopicFilter(val.key)
          } else {
            this.resetTopicFilter()
          }
        },
      },
    },
    created() {
      this.getNewsFilters()
    },
    methods: {
      ...mapActions('news', [
        'getNewsFilters',
        'getTopicFilter',
        'resetFilter',
        'resetTopicFilter',
        'updateFilters',
      ]),
      onResetFilter() {
        this.filters = {}
        this.resetFilter()
        this.$emit('onResetFilter')
        this.isDisabled = true
      },
      onResultUpdate(id, args) {
        this.$set(this.filters, id, args)
        this.updateFilters(clone(this.filters))
        this.isDisabled = false
      },
    },
  }
</script>
